import customTheme from "../../../theme";
import {
  columnsWidth,
  columnsCount,
  gutterWidths,
  marginWidths,
} from "../../constants/Login";

/** Estilos provisionales en Consumos */
const consumosStyles = {
  root: {
    height: "100vh",
    backgroundColor: customTheme.paleta.gris96,//"#f4f4f6",
    overflow: "auto",
    [customTheme.breakpoints.down("md")]: {
      overflow: "unset",
    },
    color: "#47495c",
    display:"block",
  },
  imageContainer: {
    [customTheme.breakpoints.only("sm")]: {
      display: "none",
    },
    [customTheme.breakpoints.only("xs")]: {
      display: "none",
    },
    marginTop: "auto",
    position: "fixed",
    bottom: customTheme.spacing(1),
    paddingLeft: customTheme.spacing(1),
    [customTheme.breakpoints.only("md")]: {
      width: `calc((((100% - ${columnsWidth.md}px) * 6) / ${columnsCount.md
        }) + ${gutterWidths.md * 5 + marginWidths.md * 1}px)`,
    },
    [customTheme.breakpoints.only("lg")]: {
      width: `calc((((100% - ${columnsWidth.lg}px) * 6) / ${columnsCount.lg
        }) + ${gutterWidths.lg * 5 + marginWidths.lg * 1}px)`,
    },
    [customTheme.breakpoints.only("xl")]: {
      width: `calc((((100% - ${columnsWidth.lg}px) * 6) / ${columnsCount.lg
        }) + ${gutterWidths.lg * 5 + marginWidths.lg * 1}px)`,
    },
  },

  loadingSection: {
    padding: customTheme.spacing(4),
    margin: "auto",
    alignContent: "center",
    display: "table",
  },

  appBar: {
    backgroundColor: customTheme.paleta.azul20, //customTheme.palette.primary.main,
    color: "#ffffff",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: 1.5,
    zIndex: customTheme.zIndex.drawer + 1,
  },
  logout: {
    marginTop: customTheme.spacing(0.5),
    marginLeft: customTheme.spacing(3),
    cursor: "pointer",
  },
  spacer: {
    flexGrow: 1,
  },

  breadCrumb: {
    paddingLeft: customTheme.spacing(3),
    paddingRight: customTheme.spacing(4),
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    border: "1px solid #e5e5e5",

  },

  consumosFooterTablet: {
    width:"100%",
    flexGrow: "1",
    display: "flex",
    alignItems: "center",
    padding: "8px 16px",
    position: "fixed",
    backgroundColor: "#f9f9fb",
    bottom: "0px",
    zIndex: customTheme.zIndex.drawer + 1,
  },

  modal: {
    borderRadius: "5px",
    boxShadow: customTheme.shadows[5],
    padding: customTheme.spacing(4),
  },
  modalHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    marginBottom: customTheme.spacing(2),
  },
  modalHeaderText: {
    fontSize: "24px",
    fontWeight: 500,
    color: "#373740",
    flex: 1,
  },
  modalTitle: {
    marginBottom: "4px",
    fontWeight: 500,
  },
  modalConfirmation: {
    paddingTop: "18px",
  },
  modalConfirmationSpan: {
    marginBottom: customTheme.spacing(2),
    marginTop: "0px",
  },
  modalButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  modalActionButton: {
    marginLeft: customTheme.spacing(2),
  },

};

export default consumosStyles;
